import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const MpProjects = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        showMore(event) {
            let btn = $(event.target),
                list = $(this.$el).find('.js-projects-list');

            if (!btn.hasClass('is-show')) {
                btn.addClass('is-show');
                btn.text('Свернуть');
                list.addClass('is-show');
            } else {
                btn.removeClass('is-show');
                btn.text('Показать ещё');
                list.removeClass('is-show');
                $('html').animate({
                    scrollTop: list.offset().top - 150
                }, 500);
            }
        }
    },
    updated() {

    },
    mounted() {
        if ($(this.$el).find('.js-project-item').length > 4) {
            $(this.$el).find('.js-projects-show').addClass('is-active');
        } else {
            $(this.$el).find('.js-projects-show').removeClass('is-active');
        }

        let figure = $(this.$el).find(".js-project-item").hover(hoverVideo, hideVideo);

        function hoverVideo(e) {
            if ($('video', this).length)
                $('video', this).get(0).play();
        }

        function hideVideo(e) {
            if ($('video', this).length)
                $('video', this).get(0).pause();
        }

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'ancor', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" class="section section--gray">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Более 12 000+ объектов в РФ и странах СНГ
                </h2>
            </div>
        <a href="/vypolnennye-proekty/" class="btn btn--border projects__all-link">Все проекты</a>
        </div>
        <div class="projects__mp-wp">
            <div class="row projects__mp js-projects-list">

                <div v-for="item in this.struct[this.structKey].componentData.ITEMS"
                    :key="item.ID"
                    :class="'col-12 ' + item.CARD_CLASS"
                    >
                    <ItemEditBtns v-if="item.EDIT_BUTTON" :onclick="item.EDIT_BUTTON">
                        Редактировать элемент
                    </ItemEditBtns>
                    <a :href="item.LINK" :class="'projects__item js-project-item ' + item.LINK_MODIFIER">
                        <div class="projects__item-img">
                            <img v-if="item.CARD_TYPE == 'photo'" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PREVIEW" :alt="item.NAME" :title="item.NAME">
                            <video v-if="item.CARD_TYPE == 'video'" preload="metadata" playsinline="" webkit-playsinline="" loop="" muted="">
                                <source :src="item.PREVIEW" :type="item.FILE_TYPE">
                            </video>
                        </div>
                        <div class="projects__item-top">
                            <div v-if="item.TYPE" class="projects__item-tag">
                                {{item.TYPE}}
                            </div>
                            <div class="projects__item-title">
                                {{item.NAME}}
                                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                            </div>
                            <div class="projects__item-date">
                                {{item.YEAR}}
                            </div>
                        </div>
                        <div v-if="item.CARD_TYPE == 'photo'" class="projects__item-icon">
                            <svg class="ico ico-foto" width="13" height="13" aria-hidden="true"><use xlink:href="#ico-foto"></use></svg>
                            {{item.GALLERY_COUNT}}
                        </div>
                        <div v-if="item.CARD_TYPE == 'video'" class="projects__item-icon">
                            <svg class="ico ico-play" width="17" height="18" aria-hidden="true"><use xlink:href="#ico-play"></use></svg>
                        </div>
                    </a>
                </div>
                <div class="col-12 col-lg-3">
                    <a href="/vypolnennye-proekty/#map" class="projects__item projects__item--map">
                        <div class="projects__item-img">
                            <picture>
                                <source type="image/avif" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/projects8.avif'">
                                <source type="image/webp" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/projects8.webp'">
                                <img class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="this.SITE_TEMPLATE_PATH + '/img/content/projects8.png'" alt="" title="">
                            </picture>
                        </div>
                        <div class="projects__item-title">
                            Все проекты <br> на карте
                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                        </div>
                    </a>
                </div>
            </div>
            <a href="#" class="btn btn--border js-projects-show" @click.prevent="this.showMore($event)">Показать ещё</a>
            <a href="/vypolnennye-proekty/#map" class="projects__item projects__item--map">
                <div class="projects__item-img">
                    <picture>
                        <source type="image/avif" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/projects8.avif'">
                        <source type="image/webp" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/projects8.webp'">
                        <img class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="this.SITE_TEMPLATE_PATH + '/img/content/projects8.png'" alt="" title="">
                    </picture>
                </div>
                <div class="projects__item-title">
                    Все проекты <br> на карте
                    <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                </div>
            </a>
        </div>
    </div>
</section>
    `
}